export default __webpack_public_path__ + "static/media/404.821723a3.jpg";